module.exports = __webpack_public_path__ + "img/2_1-parcheggio-0.0da140b4.png";